import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { EntityDefinitionDto } from '../../models/item/entity-definition';

@Injectable({
  providedIn: 'root',
})
export class EntityDefinitionProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/entity-definition';

  public getAll(): Observable<ApiResponse<EntityDefinitionDto[]>> {
    return this.httpClient.get<ApiResponse<EntityDefinitionDto[]>>(`${this.baseUrl}/all`);
  }
}
